// extracted by mini-css-extract-plugin
export default {"errorBanner":"pdf-viewer_errorBanner__9K9RU"};